export class Campaign {
    constructor({
                    //attributes
                    id= null,
                    company = null,
                    pipe= null,
                    name= '',
                    image= '',
                    title= '',
                    token= 'pf',
                    objective= {},
                    extradata= {},
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                } = {}) {

        //fill attributes

        this.id= id;
        this.company=company;
        this.pipe=pipe;
        this.name=name;
        this.image=image;
        this.title=title;
        this.token=token;
        this.objective=objective;
        this.extradata=extradata;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;


    }

}

export function createCampaign(data={}) {
    return Object.freeze(new Campaign(data));
}